module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.permissao) ? _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "painel"
  }, [_c('div', {
    staticClass: "notificacoes"
  }, [_c('div', {
    staticClass: "cabecalho-notificacoes"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "h2 mb-0 icon-detalhe-notificacao"
  }, [_c('router-link', {
    attrs: {
      "to": "/ListarNotificacoes"
    }
  }, [_c('b-icon-arrow-left-short')], 1)], 1)]), _vm._v(" "), _c('h2', [_vm._v("Notificação n° " + _vm._s(_vm.notificacaoAtual.id))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-borderless",
    attrs: {
      "id": "tabelaControle"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.usuario))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.numero_contrato))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.mes_referencia))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.ano_referencia))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.descricao))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('td', [_vm._v(_vm._s(_vm.notificacaoAtual.data_envio))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [(_vm.notificacaoAtual.data_resposta_esperada !== null) ? _c('td', [_vm._v("\n                  " + _vm._s(_vm.notificacaoAtual.data_resposta_esperada) + "\n                ")]) : _c('td', [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("-")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [(_vm.notificacaoAtual.arquivo) ? _c('td', [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.notificacaoAtual.arquivo)
      }
    }
  }, [_vm._v("Download")])]) : _c('td', [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [(_vm.notificacaoAtual.status === 'Concorda') ? _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.notificacaoAtual.status))])]) : (
    _vm.notificacaoAtual.status === 'Sem resposta'
  ) ? _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.notificacaoAtual.status))])]) : _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.notificacaoAtual.status))])])])]), _vm._v(" "), _c('br')])]), _c('hr'), _vm._v(" "), [_c('div', {
    staticClass: "accordion",
    attrs: {
      "role": "tablist"
    }
  }, [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-2",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ('accordion-2'),
      expression: "'accordion-2'"
    }],
    class: 'text-head'
  }, [_c('strong', [_vm._v("Histórico")])])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": 'accordion-2'
    }
  }, [_c('b-card-body', {
    staticClass: "bcard01"
  }, [_c('table', {
    staticClass: "table table-borderless",
    attrs: {
      "id": "tabelaControleHistorico"
    }
  }, [_c('tbody', _vm._l((_vm.historico), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('p', [_c('b', [_vm._v("Nome: ")]), _vm._v(" " + _vm._s(item.usuario))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(" " + _vm._s(item.email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ação: ")]), _vm._v(_vm._s(item.acao))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Data: ")]), _vm._v(_vm._s(_vm.formataData(item.created_at)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("UF: ")]), _vm._v(_vm._s(item.uf))])])])
  }), 0)])])], 1)], 1)], 1)]], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.notificacaoAtual
    }
  })])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('h4', {
    staticClass: "sub-header"
  }, [_vm._v("Dados da Notificação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Quem criou:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Contrato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Mês de referência:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Ano de referência:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Descrição:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Data de envio:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Data resposta esperada:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Arquivo:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4"
  }, [_c('td', [_c('strong', [_vm._v("Status notificação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c27ffc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notificacao/ExibirNotificacao.vue
// module id = 989
// module chunks = 1